import { ChangeEvent } from 'react'
import { Input } from '@/components/ui/input'
import { InputDecimal } from '../decimalInput'
import { InputQuantityProps } from './types'

export default function OpenQuantityInput({
  disabled,
  inputId,
  onChangeValue,
  onChangeUnit,
  required,
  value
}: InputQuantityProps) {
  function handleOpenChange(event: ChangeEvent<HTMLInputElement>) {
    onChangeUnit(event.target.value)
  }

  return (
    <div className='grid grid-cols-12 gap-2'>
      <div className='col-span-8'>
        <InputDecimal
          disabled={disabled}
          id={inputId}
          name={`${inputId}-quantity`}
          onChange={onChangeValue}
          required={required}
          value={value?.value?.toString()}
        />
      </div>
      <div className='col-span-4'>
        <Input
          disabled={disabled}
          name={`${inputId}-unit`}
          onChange={handleOpenChange}
          placeholder='unit'
          required={required}
          type='text'
          value={value?.unit ?? ''}
        />
      </div>
    </div>
  )
}
